import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'htmlToText',
  standalone: true
})
export class HtmlToTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return ''
    const div = document.createElement('div')
    div.innerHTML = value
    return div.textContent || div.innerText || ''
  }
}
